'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { readActiveOptimizelyCampaigns, subscribeToOptimizelyCampaignChanges } from './readActiveOptimizelyCampaigns';
import type { OptimizelyActiveCampaign } from './types';

/** Tracks active Optimizely Web campaigns while C0002 is granted. */
export function useGetActiveOptimizelyCampaigns(hasC0002) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [campaigns, setCampaigns] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== hasC0002) {
    t1 = () => {
      if (!hasC0002) {
        setCampaigns([]);
        return;
      }
      let cancelled = false;
      const refresh = () => {
        const next = readActiveOptimizelyCampaigns();
        if (!cancelled) {
          setCampaigns(previous => JSON.stringify(previous) === JSON.stringify(next) ? previous : next);
        }
      };
      refresh();
      const unsubscribe = subscribeToOptimizelyCampaignChanges(refresh);
      return () => {
        cancelled = true;
        unsubscribe();
      };
    };
    t2 = [hasC0002];
    $[1] = hasC0002;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return campaigns;
}